
import {InputSizeEnum} from "@/models/enum/InputSizeEnum";
import {DpException} from "@/exception/DpException";
import {defineComponent} from "vue";
import {Tooltip} from "bootstrap";
import {PropType} from "vue/dist/vue";

export default defineComponent({
  emits: [
    'update:modelValue',
    'blur'
  ],
  props: {
    modelValue: {
      type: String,
    },
    label: {
      type: String,
    },
    name: {
      type: String,
    },
    errors: {
      type: Object,
    },
    rules: {
      type: String,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    help: {
      type: String,
      required: false,
      default: null,
    },
    inputSize: {
      type: String as PropType<InputSizeEnum>,
      required: false,
      default: InputSizeEnum.SM,
    },
    language: {
      type: String,
      required: false,
    },
    fieldClass: {
      type: String,
      required: false,
      default: '',
    },

    // BOOLEANS
    canClear: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isFloating: {
      type: Boolean,
      required: false,
      default: true,
    },
    isMultilingual: {
      type: Boolean,
      required: false,
      default: false,
    },
    withPasswordPreview: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      enums: {
        inputSizeEnum: InputSizeEnum,
      },
      inputType: this.determineInputType(),
    };
  },
  computed: {
    fieldClasses() {
      return {
        'form-control-sm': (this.inputSize === this.enums.inputSizeEnum.SM),
        'form-control-lg': (this.inputSize === this.enums.inputSizeEnum.LG),
        'is-invalid': this.errors && this.name && this.errors[this.name],
        [this.fieldClass]: this.fieldClass
      };
    }
  },
  mounted() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
      new Tooltip(el as Element);
    });
  },
  methods: {
    determineInputType(): string {
      throw [new DpException('Child component should overwrite determineInputType():string')];
    },
    determineRules(): string[] {
      return [];
    },
    determineStep(): number | null {
      return null;
    },
    determinePlaceholder(): string | null {
      return null;
    },
    getPlaceholder(): string {
      return this.determinePlaceholder() ?? this.placeholder ?? this.label;
    },
    getRulesAsString(): string {
      return (this.rules ?? '')
        .split('|')
        .concat(this.determineRules())
        .join('|');
    },
    clearValue() {
      this.$emit('update:modelValue', null);
    },
    updateValue(value: any) {
      this.$emit('update:modelValue', value);
    },
    checkRequired(rules: any) {
      if (rules && rules.includes("required")) {
        return true;
      }
    },
    isInputType(type: string): boolean {
      return type === this.determineInputType();
    },
    togglePasswordPreview(): void {
      if (this.inputType === 'password') {
        this.inputType = 'text';
      } else {
        this.inputType = 'password';
      }
    }
  },
});
